import { clamp } from '@/helpers/functions';
import { MapZoom, LOCATION_CHANGE } from '@/helpers/constants';
import { UNDO, REDO } from '@/store/actions/edit_ride';
import { EDIT_WAYPOINT } from '@/store/actions/edit_ride/waypoints';
import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { initialState, UPDATE, BOUNDS, CENTER_ZOOM } from '@/store/actions/map';

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE: {
            const { field, value, data } = action.data;
            return {
                ...state,
                sidebarData: data,
                [field]:
                    field === 'zoom'
                        ? clamp(value, MapZoom.MIN, MapZoom.MAX)
                        : value
            };
        }

        case BOUNDS: {
            const { bounds } = action.data;
            return {
                ...state,
                bounds
            };
        }

        case CENTER_ZOOM: {
            const { center, zoom: nextZoom, priority } = action.data;

            // can't set an invalid lat/lng
            if (!center.lat || !center.lng) {
                return state;
            }

            const zoom = clamp(nextZoom, MapZoom.MIN, MapZoom.MAX);

            // passive center
            if (typeof priority === 'number') {
                return priority > state.centerPriority
                    ? {
                          ...state,
                          center,
                          zoom: typeof zoom === 'undefined' ? state.zoom : zoom,
                          centerPriority: priority
                      }
                    : state;
            }

            // force center
            return { ...state, center, zoom };
        }

        case UNDO:
        case REDO: {
            return { ...state, selectedData: null };
        }

        case EDIT_WAYPOINT: {
            // if selectedData is actually a waypoint, update it
            const { id, edits } = action.data;
            const { selectedData } = state;
            return (selectedData || {}).id === id
                ? { ...state, selectedData: { ...selectedData, ...edits } }
                : state;
        }

        case LOCATION_CHANGE: {
            return state;
        }

        case AUTH_INVALIDATE:
        default: {
            return state;
        }
    }
};
